module.exports = __webpack_public_path__ + "static/img/ewm.87e177b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ewm.png
// module id = bYLY
// module chunks = 0